import { useSelector } from "react-redux";

function useAuth() {
  const { token, signedIn } = useSelector((state) => state.auth.session);

  return {
    authenticated: token && signedIn,
  };
}

export default useAuth;
